module.exports = __webpack_public_path__ + "media/fonts/TomaSlab-SemiBold-6ebcda7a10cdcb998107aacaf13baa4e.woff";